// Port of sge_infantil_web's src/utils/authority.ts, kept storage-key compatible
// with the original backend/session behaviour.
export function getAuthority(str) {
  const authorityString =
    typeof str === 'undefined' && localStorage ? localStorage.getItem('antd-pro-authority') : str;
  let authority;
  if (authorityString) {
    try {
      authority = JSON.parse(authorityString);
    } catch (e) {
      authority = authorityString;
    }
  }
  if (typeof authority === 'string') {
    return [authority];
  }
  return authority;
}

export function setAuthority(authority) {
  const proAuthority = typeof authority === 'string' ? [authority] : authority;
  localStorage.setItem('antd-pro-authority', JSON.stringify(proAuthority));
}
